import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ph1Select", "ph2Select", "ph3Select"]
  static values = {
    clientId: String,
    ph1Id: String,
    ph2Id: String,
    ph3Id: String
  }

  connect() {
    // Initialize is handled by Rails-generated selects
  }

  async ph1Changed(event) {
    const ph1Id = event.target.value

    // Clear PH2 and PH3 when PH1 changes
    this.clearSelect(this.ph2SelectTarget)
    this.clearSelect(this.ph3SelectTarget)

    if (!ph1Id) {
      return
    }

    // Fetch PH2 options for the selected PH1
    await this.loadPh2Options(ph1Id)
  }

  async ph2Changed(event) {
    const ph2Id = event.target.value

    // Clear PH3 when PH2 changes
    this.clearSelect(this.ph3SelectTarget)

    if (!ph2Id) {
      return
    }

    // Fetch PH3 options for the selected PH2
    await this.loadPh3Options(ph2Id)
  }

  clearSelect(selectElement) {
    // Keep only the first option (the blank option)
    while (selectElement.options.length > 1) {
      selectElement.remove(1)
    }
    selectElement.selectedIndex = 0
  }

  async loadPh2Options(ph1Id) {
    try {
      const response = await fetch(`/api/v1/product_hierarchy_nodes?parent_id=${ph1Id}&level=ph2`)
      const data = await response.json()

      data.forEach(node => {
        const option = new Option(node.name, node.id)
        this.ph2SelectTarget.add(option)
      })
    } catch (error) {
      console.error('Error loading PH2 options:', error)
    }
  }

  async loadPh3Options(ph2Id) {
    try {
      const response = await fetch(`/api/v1/product_hierarchy_nodes?parent_id=${ph2Id}&level=ph3`)
      const data = await response.json()

      data.forEach(node => {
        const option = new Option(node.name, node.id)
        this.ph3SelectTarget.add(option)
      })
    } catch (error) {
      console.error('Error loading PH3 options:', error)
    }
  }
}
